// src/utils/media.js
import { getAssetUrl } from "../config";

export const getMediaUrls = (photo) => {
  const mediaType = String(photo?.media_type || "PHOTO").toUpperCase();
  const isVideo = mediaType === "VIDEO";

  const rawThumb = photo?.thumbnail_path || null;
  const rawFile = photo?.file_path || null;

  // Detect in-progress video processing (backend stores raw_ path until proxy is ready)
  const isProcessingVideo =
    isVideo && typeof rawFile === "string" && rawFile.includes("/raw_");

  // Photos:
  const imageUrl = !isVideo ? getAssetUrl(rawThumb || rawFile) : null;

  // Videos:
  // While processing, avoid pointing the <video> tag at the raw file (we want a consistent UX).
  const videoUrl = isVideo && !isProcessingVideo ? getAssetUrl(rawFile) : null;
  const posterUrl = isVideo && rawThumb ? getAssetUrl(rawThumb) : null;

  // Lightbox should prefer full-quality file if available
  const lightboxUrl = getAssetUrl(rawFile || rawThumb);

  return { isVideo, isProcessingVideo, imageUrl, videoUrl, posterUrl, lightboxUrl };
};
